export default __webpack_public_path__ + "static/media/btanidjaxxx-color.59343cd6.svg";